const ClientTable = ({ clients, onRowClick }) => {
  return (
    <div className="bg-white shadow rounded overflow-hidden">
      <table className="min-w-full divide-y">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-3 text-left">Client Code</th>
            <th className="p-3 text-left">Client Name</th>
            <th>Entity Type</th>
            <th>PAN</th>
            <th>GSTIN</th>
          </tr>
        </thead>

        <tbody>
          {clients.map((c) => (
            <tr
              key={c.ClientID}
              onClick={() => onRowClick(c.ClientID)}
              className="border-t hover:bg-gray-50 cursor-pointer"
            >
              <td className="p-3 font-mono text-sm">
                {c.ClientCode}
              </td>
              <td className="p-3 font-medium">
                {c.ClientName}
              </td>
              <td>{c.EntityType || "-"}</td>
              <td>{c.PAN || "-"}</td>
              <td>{c.GSTIN || "-"}</td>
            </tr>
          ))}

          {clients.length === 0 && (
            <tr>
              <td colSpan="4" className="p-4 text-center text-gray-400">
                No clients found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ClientTable;
